import { useParams } from 'react-router-dom';
import { Card } from '@nearst/ui';

import StockLevels from '.';

const StockLevelsCard = () => {
	const { barcode, shopId } = useParams();
	return (
		<Card title="Stock levels">
			<StockLevels barcode={barcode} shopId={shopId} />
		</Card>
	);
};

export default StockLevelsCard;
